import React, { Component } from 'react';
import './Login.scss'
import MFASetup from '../MFASetup';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getMultifactorStatus, loginUser, doMultiFactorSetup } from '../../Redux/Actions/loginActions';
import { updateUserData, getBotListData, getGenericData, getSelectedBotData, blockUiFun, getBotInfo } from '../../Redux/Actions/uiActions';
import history from '../../Routers/history';
import { LoginV4, InputV3, ButtonV3, rlibfn } from 'react-ui-lib';
import BotForgeIcon from '../../../assets/icons/botForge.png';
import LEFT_ARROW_ICON from '../../../assets/icons/black_back.svg';


const setToStorage = (fieldName, value) => {
    localStorage.removeItem("bot_id");
    localStorage.removeItem("bot_name");
    localStorage.setItem(fieldName, value);
};

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            renderState: 'initial',
            errorMsg: '',
            userDef: {
                userName: '',
                password: '',
                MFACode: ''
            },
            headerTitle: null,
            headerMessage: null,
            relogin: null,
            cancelReLoginBtn: false,
            spinnerStatus: false,
            reloginstart: false,
            visibilityState: false,
            headerTitleData: {
                title: props.headerTitle || "Hello!",
                subTitle: props.headerMessage || "Good to have you back"
            }
        }
    }

    handleFlashMessage = (data, notifyType) => {
        if(data && data.code && data.code === 1004) {
            this.setState({ 'errorMsg': data.message, spinnerStatus:false });
        } else {
            if(typeof data !== 'string') {
                data = data?.toString();
            }
            this.setState({ 'errorMsg': data, spinnerStatus:false });
        }
        this.timeoutId = setTimeout(() => {
            this.setState({ 'errorMsg': '' });
        }, 3000);
    }

    handleKeypress(e, loginType) {
        if (e.key === "Enter") {
            if (loginType === 'initial') {
                this.getMultifactorStatus(e);
            } else {
                this.loginUser(loginType);
            }
        }
    }

    loginUser = (e, loginType) => {
        e.preventDefault();
        const { userDef } = this.state;
        this.setState({ spinnerStatus:true })
        let payload;
        let currentBotID = localStorage.getItem('bot_id');
        if (this.validateUserDef(userDef, loginType)) {
            if (loginType === 'noMFALogin' || loginType === 'relogin') {
                // console.log("Login user without MFA");
                payload = {
                    user: userDef.userName,
                    pwd: userDef.password
                }
                this.props.loginUser(payload, this.handleFlashMessage, this.state.relogin, (data) => {
                    this.setState({ 
                        spinnerStatus:false,
                        userDef: {
                            userName: '',
                            password: '',
                            MFACode: ''
                        } 
                    })
                    this.props.updateUserData(data);
                    // this.props.getBotListData();
                    if(!this.props.reloginState) {
                        localStorage.removeItem('bot_id');
                        // history.push('/');
                        history.push('/bot-list');
                    } else {
                        this.props.blockUiFun(true);
                        this.props.getBotListData(() => {
                        }, () => {
                            this.props.blockUiFun(false);
                        });
                        this.props.getGenericData(this.props.currentLanguage, (res) => {
                            localStorage.setItem('bot_id', currentBotID);
                            this.props.getBotInfo(currentBotID);
                            this.props.getSelectedBotData(currentBotID, () => {
                                setTimeout(() => {this.props.blockUiFun(false);}, 3000)
                                
                            }, () => {
                                this.props.blockUiFun(false);
                            });
                            history.push('' + window.location.pathname);
                        });
                    }
                });
                // login user without mfa
            } else if (loginType === 'MFASetupLogin') {
                payload = {
                    email: userDef.userName,
                    password: userDef.password,
                    stage: 'emailCode'
                }
                this.setState({ spinnerStatus:false })
                this.props.doMultiFactorSetup(payload, this.handleFlashMessage, (data, res) => {
                    if(data === 'email-auth') {
                        this.setState({ renderState: 'MFASetup' })
                    }
                })
    
            } else {
                // console.log("Login user with MFA");
                let payload = {
                    user: userDef.userName,
                    pwd: userDef.password,
                    passCode: userDef.MFACode
                }
                this.props.loginUser(payload, this.handleFlashMessage, this.state.relogin, (data) => {
                    this.setState({ spinnerStatus:false })
                    this.props.updateUserData(data);
                    // this.props.getBotListData();
                    if(!this.props.reloginState) {
                        localStorage.removeItem('bot_id');
                        // history.push('/');
                        history.push('/bot-list');
                    } else {
                        this.props.blockUiFun(true);
                        this.props.getBotListData(() => {
                        }, () => {
                            this.props.blockUiFun(false);
                        });
                        this.props.getGenericData(this.props.currentLanguage, (res) => {
                            localStorage.setItem('bot_id', currentBotID);
                            this.props.getBotInfo(currentBotID);
                            this.props.getSelectedBotData(currentBotID, () => {
                                this.props.blockUiFun(false);
                            }, () => {
                                this.props.blockUiFun(false);
                            });
                            history.push('' + window.location.pathname);
                        });
                    }
                });
            }
        }
    };

    doValidateOTC = (payload, cb, handleFlashMessage) => {
        const { userDef } = this.state;
        payload.email = userDef.userName;
        payload.password = userDef.password;
        this.props.doMultiFactorSetup(payload, handleFlashMessage, cb)
    }

    onSetupSuccess = () => {
        if (this.timeoutId) {
          clearTimeout(this.timeoutId);
          this.setState({ 'errorMsg': '' });
        }
        let userDef = { ...this.state.userDef };
        userDef.password = '';
        this.setState({ renderState: 'MFALogin', userDef });
    }

    onLoginClickedFromQrCode = () => {
        this.onSetupSuccess();
    }

    userChange = (e) => {
        let userDef = { ...this.state.userDef };
        userDef[e.target.name] = e.target.value ? e.target.value.trim() : "";
        this.setState({
            userDef: userDef,
            errorMsg: ''
        });
    };

    validateUserDef = (userDef, loginType) => {
        if (loginType === 'noMFALogin' || loginType === 'relogin') {
            if (userDef.password === null || userDef.password === '') {
                this.handleFlashMessage("Password shouldn't be empty!", "error");
                return false;
            } else return true;
        } else if (loginType === 'MFASetupLogin') {
            if (userDef.password === null || userDef.password === '') {
                this.handleFlashMessage("Password shouldn't be empty!", "error");
                return false;
            } else return true;
        } else {
            if (userDef.password === null || userDef.password === '') {
                this.handleFlashMessage("Password shouldn't be empty!", "error");
                return false;
            } else if (userDef.MFACode === null || userDef.MFACode === '') {
                this.handleFlashMessage("Authentication code shouldn't be empty", "error");
                return false;
            } else if (userDef.MFACode.length < 6 || userDef.MFACode.length > 6) {
                this.handleFlashMessage("Invalid credentials ", "error");
                return false;
            } else return true;
        }
    }

    validateEmail = (emailField) => {
        var reg = /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
        if (emailField.length < 1) {
            this.handleFlashMessage("Email shouldn't be empty!!", "error");
            return false
        } else {
            if (reg.test(emailField)) {
                return true;
            } else {
                this.handleFlashMessage("Email is not valid!!", "error");
                return false;
            }
        }
    }

    handleGoBack = () => {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
            this.setState({ 'errorMsg': '', userDef: {
                userName: this.state.userDef.userName,
                password: '',
                MFACode: ''
            } });
        }
        this.setState({ renderState: 'initial' })
    }

    handleCancelRelogin = () => {
        localStorage.clear();
        window.location.href = '/';
    }

    getMultifactorStatus = (e, userObj, relogin) => {
        e && e.preventDefault();
        const { userDef } = this.state;
        if(!relogin) {
            this.setState({spinnerStatus:true});
            if (this.timeoutId) {
                clearTimeout(this.timeoutId);
                this.setState({ 'errorMsg': '' });
            }
        }
        if (userObj && userObj.userName) {
            this.props.getMultifactorStatus(userObj, (res) => {
                if (res.enabled && res.setup) {
                    if(relogin) {
                        this.setState({ renderState: 'MFARelogin' });
                    } else {
                        this.setState({ renderState: 'MFALogin' })
                    }
                } else if (!res.enabled) {
                    if(relogin) {
                        this.setState({ renderState: 'relogin' });
                    } else {
                        this.setState({ renderState: 'noMFALogin' });
                    }
                } else {
                    this.setState({ renderState: 'MFASetupLogin' });
                }
                this.setState({ userDef: userObj, spinnerStatus:false })
            }, this.handleFlashMessage);
        } else if (this.validateEmail(userDef.userName)) {
            this.props.getMultifactorStatus(userDef, (res) => {
                if (res.enabled && res.setup) {
                    if(relogin) {
                        this.setState({ renderState: 'MFARelogin' });
                    } else {
                        this.setState({ renderState: 'MFALogin' })
                    }
                } else if (!res.enabled) {
                    if(relogin) {
                        this.setState({ renderState: 'relogin' });
                    } else {
                        this.setState({ renderState: 'noMFALogin' });
                    }
                } else {
                    this.setState({ renderState: 'MFASetupLogin' });
                }
                this.setState({ spinnerStatus:false })
            }, this.handleFlashMessage);
        }
        return false;
    }

    renderHeader = () => {
        const { renderState } = this.state;
        switch (renderState) {
            case 'reloginState':
                this.setState({
                    headerTitleData: {
                        title: "Hello!",
                        subTitle: "Good to have you back"
                    }
                })
                break;
            case 'initial':
                this.setState({
                    headerTitleData: {
                        title: "Hello!",
                        subTitle: "Good to have you back"
                    }
                })
                break;
            case 'relogin':
                this.setState({
                    headerTitleData: {
                        title: "Oops!",
                        subTitle: "Your session has expired. Please sign in again to continue with your work"
                    }
                })
            case 'noMFALogin':
                this.setState({
                    headerTitleData: {
                        title: "Hello!",
                        subTitle: "Please provide your password below to login."
                    }
                })
            case 'MFASetupLogin':
                this.setState({
                    headerTitleData: {
                        title: "Hello!",
                        subTitle: "2-Factor Authentication is not setup on your account. Enter your password to start the setup process. An email will be sent to your email address."
                    }
                })
                break;
            case 'MFARelogin':
                this.setState({
                    headerTitleData: {
                        title: "Oops!",
                        subTitle: "Your session has expired. Please sign in again to continue with your work"
                    }
                })
            case 'MFALogin':
                this.setState({
                    headerTitleData: {
                        title: "Hello!",
                        subTitle: "Please provide your password below to login."
                    }
                })                           
                break;
            case 'MFASetup':
                this.setState({
                    headerTitleData: {
                        title: "2FA Setup!",
                        subTitle: "Please enter verification code sent to your email."
                    }
                })
                break;
            default:
                this.setState({
                    headerTitleData: {
                        title: "Hello!",
                        subTitle: "Good to have you back"
                    }
                })
                break;
        }
    };

    renderLoginView = () => {
        const { renderState } = this.state;
        let dom = '';
        switch (renderState) {
            case 'reloginState':
                this.getMultifactorStatus(null, null, this.props.reloginState);
                break;
            case 'initial':
                dom = this.renderInitialLoginView();
                break;
            case 'relogin':
            case 'noMFALogin':
            case 'MFASetupLogin':
                dom = this.renderNoMFALogin(renderState);
                break;
            case 'MFARelogin':
            case 'MFALogin':
                dom = this.renderMFALogin(renderState);
                break;
            case 'MFASetup':
                dom = (
                <MFASetup
                    // onSetupSuccess={this.onSetupSuccess} 
                    onLoginClickedFromQrCode={this.onLoginClickedFromQrCode}
                    email={this.state.userDef.userName}
                    doValidateOTC={this.doValidateOTC}
                />
                );
                break;
            default:
                break;
        }
        return dom;
    };

    renderInitialLoginView = () => {
        const { userDef, errorMsg } = this.state;
        const spinnerClass = 'loader-onboard-overlay' + (this.state.spinnerStatus ? ' spinner' : '');
        try {
            localStorage.clear();
        } catch(e) {}
        return (
            <form onSubmit={this.getMultifactorStatus}>
                <div className={spinnerClass} id='onboardLoadingId'></div>
                <h1 class="loginHeader">Hello!</h1>
                <h3 class="loginSubHeader">Good to have you back</h3>
                <div className="row" style={{ marginBottom: '2em' }}>
                    <div className="col">
                        <InputV3
                            label="Registered email"
                            name="userName"
                            placeholder="john@docbrain.ai"
                            bgcolor="white"
                            width="-webkit-fill-available"
                            onChange = {this.userChange}
                            value = {userDef.userName}
                            inputstyle={{ width: '100%', padding: '1.2em 1em', height: 'auto' }}
                            autoFocus
                        />
                    </div>
                    <div className="col-sm-12">
                        <div className="login-error" style={{display:'block'}} >{errorMsg}</div> 
                    </div>
                </div>
                <div className="row" style={{ marginBottom: '1.3em' }}>
                    <div className="col">
                        <ButtonV3
                            btnstyle={{ width: '100%', padding: '1.2em', height: 'auto' }}
                            name="Next"
                            disabled={userDef.userName.length ? false : true}
                            type="submit"
                        />
                    </div>
                </div>
            </form>
        )
    }
    
    renderNoMFALogin = (renderState) => {
        const { userDef, spinnerStatus, visibilityPassState, cancelReLoginBtn, errorMsg } = this.state;
        const spinnerClass = 'loader-onboard-overlay' + (spinnerStatus ? ' spinner' : '');
        return (
            <form onSubmit={(e) => this.loginUser(e,renderState)}>
                <div className={spinnerClass} id='onboardLoadingId'></div>
                <div className="row" style={{ marginBottom: '1em' }}>

                    <div id="btn-left">
                        {renderState === 'relogin' ?
                            <ButtonV3 
                                key='Exit' 
                                name="Exit" 
                                color='#8B8B8B'
                                bgcolor='white' 
                                border="1px solid #CECECE"
                                type="button"
                                onClick={() => this.handleCancelRelogin()}
                                btnstyle={{
                                  borderRadius: "3px",
                                  fontSize: "16px",
                                  padding: "0",
                                  border: "none"
                                }}
                                data-login="exit"
                            />
                            :  
                            <ButtonV3 
                                key='Back' 
                                name="Back" 
                                color='#8B8B8B'
                                bgcolor='white'
                                border="1px solid #CECECE"
                                type="button"
                                onClick={() => this.handleGoBack()}
                                id="signBackId"
                                btnstyle={{
                                  borderRadius: "3px",
                                  fontSize: "16px",
                                  padding: "0",
                                  border: "none"
                                }}
                                leftIcon={<img src={LEFT_ARROW_ICON} alt="left-arrow" />}
                                data-login="back"
                            />       
                        } 
                        </div>
                </div>
                {cancelReLoginBtn ? <><h1 class="loginHeader">Oops!</h1><span class="loginSubHeader">Your session has expired. Please sign in again to continue with your work.</span></> : renderState === 'noMFALogin' ? <><h1 class="loginHeader">Hello!</h1><span class="loginSubHeader">Please provide your password below to login.</span></> : <><h1 class="loginHeader">Hello!</h1><span class="loginSubHeader">2-Factor Authentication is not setup on your account. Enter your password to start the setup process. An email will be sent to your email address.</span></>}
                <div className="row" style={{ marginTop: '2em', marginBottom: '2em' }}>
                    <div className="col">
                        <InputV3
                            label='Registered email'
                            name='userName'
                            placeholder='john@docbrain.ai'
                            bgcolor="white"
                            width="-webkit-fill-available"
                            disabled={true}
                            color="gray"
                            value={userDef.userName}
                            containerstyle={{
                                margin:0
                            }}
                            labelstyle={{paddingLeft:0}}
                            inputstyle={{ width: '100%', padding: '1.2em 1em', height: 'auto' }} //SN-552
                        />
                    </div>
                </div>
                <div className="row" style={{ marginBottom: '2em' }}>
                    <div className="col">
                        <InputV3
                            label="Password"
                            name="password"
                            type="password"
                            placeholder="Enter your Password..."
                            bgcolor="white"
                            width="-webkit-fill-available"
                            inputstyle={{ width: '100%', padding: '1.2em 1em', height: 'auto' }}
                            onChange={this.userChange}
                            value={userDef.password}
                            showeye={true}
                            // eyeStyle={{ marginTop: "-37px" }}
                            autoFocus
                        />
                    </div>
                    <div className="col-sm-12">
                        <div className="login-error" style={{display:'block'}} >{errorMsg}</div> 
                    </div>
                </div>
                <div className="row" style={{ marginBottom: '1.3em' }}>
                    <div className="col">
                        <ButtonV3
                            btnstyle={{ width: '100%', padding: '1.2em', height: 'auto' }}
                            type="submit"
                            name={cancelReLoginBtn ? 'Continue' : renderState === 'noMFALogin' ? 'Sign In' : 'Setup'}
                            disabled={userDef.password.length ? false : true}
                        />
                    </div>
                </div>
            </form>
        )
    }
    
    renderMFALogin = (renderState) => {
        const { userDef, spinnerStatus, cancelReLoginBtn, errorMsg } = this.state;
        const spinnerClass = 'loader-onboard-overlay' + (spinnerStatus ? ' spinner' : '');
        return (
            <form onSubmit={(e) => this.loginUser(e, 'mfaLogin')}>
                <div className={spinnerClass} id='onboardLoadingId'></div>
                <div className="row" style={{ marginBottom: '1em' }}>
                    <div id="btn-left">
                        {renderState === 'MFARelogin' ?
                            <ButtonV3 
                                key='Exit' 
                                name="Exit" 
                                color='#8B8B8B'
                                bgcolor='white' 
                                border="1px solid #CECECE"
                                type="button"
                                onClick={() => this.handleCancelRelogin()}
                                btnstyle={{
                                  borderRadius: "3px",
                                  fontSize: "16px",
                                  padding: "0",
                                  border: "none"
                                }}
                                data-login="exit"
                            />
                            :  
                            <ButtonV3 
                                key='Back' 
                                name="Back" 
                                color='#8B8B8B'
                                bgcolor='white'
                                border="1px solid #CECECE"
                                type="button"
                                onClick={() => this.handleGoBack()}
                                id="signBackId"
                                btnstyle={{
                                  borderRadius: "3px",
                                  fontSize: "16px",
                                  padding: "0",
                                  border: "none"
                                }}
                                leftIcon={<img src={LEFT_ARROW_ICON} alt="left-arrow" />}
                                data-login="back"
                            />     
                        } 
                    </div>
                </div>
                {renderState === 'MFARelogin' ? <><h1 class="loginHeader">Oops!</h1><span class="loginSubHeader">Your session has expired. Please sign in again to continue with your work.</span></> : <><h1 class="loginHeader">Hello!</h1><span class="loginSubHeader">Please provide your password below to login.</span></>}
                <div className="row" style={{ marginTop: '2em', marginBottom: '2em' }}>
                    <div className="col">
                        <InputV3
                            label='Registered email'
                            name='userName'
                            placeholder='john@docbrain.ai'
                            bgcolor="white"
                            width="100%"
                            disabled={true}
                            color="gray"
                            value={userDef.userName}
                            containerstyle={{
                                margin:0
                            }}
                            labelstyle={{paddingLeft:0}}
                            inputstyle={{paddingRight:"3em",padding: '1.2em 1em'}} //SN-552
                        />
                    </div>
                </div>
                <div className="row" style={{ marginBottom: '2em' }}>
                    <div className="col">
                        <InputV3
                            label="Password"
                            name="password"
                            type="password"
                            placeholder="Enter your Password..."
                            bgcolor="white"
                            width="-webkit-fill-available"
                            inputstyle={{paddingRight:"3em",padding: '1.2em 1em'}}
                            onChange={this.userChange}
                            autoFocus
                            value={userDef.password}
                            showeye={true}
                            eyeStyle={{ marginTop: "-37px" }}
                        />
                    </div>
                </div>
                <div className="row" style={{ marginBottom: '2em' }}>
                    <div className="col">
                        <InputV3
                            label="Authentication code"
                            name='MFACode'
                            type="password"
                            placeholder="Enter your code.."
                            bgcolor="white"
                            width="-webkit-fill-available"
                            inputstyle={{paddingRight:"3em",padding: '1.2em 1em'}}
                            onChange={this.userChange}
                            showeye={true}
                            eyeStyle={{ marginTop: "-37px" }}
                        />
                    </div>
                    <div className="col-sm-12">
                        <div className="login-error" style={{display:'block'}} >{errorMsg}</div> 
                    </div>
                </div>
                <div className="row" style={{ marginBottom: '1.3em' }}>
                    <div className="col">
                        <ButtonV3
                            btnstyle={{ width: '100%', padding: '1.2em', height: 'auto' }}
                            name={cancelReLoginBtn ? 'Continue' : 'Sign In'}
                            type="submit"
                        />
                    </div>
                </div>
            </form>
        )
    }

    reloginCurrentUser = () => {
        this.setState({
            reloginstart: true,
            renderState: 'reloginState',
            userDef: {
                userName: this.props.currentEmail, 
                password: "", 
                MFACode: ""
            },
            headerTitle: 'Oops!', 
            headerMessage: 'Your session has expired. Please log in again to continue with your work.',
            cancelReLoginBtn: true
        })
    }

    onLoginSuccess = (response) => {
        const data = response?.data || response;
        // const data = response;
        // const data = response?.data?.data; // for lbadmin
        if (!data?.roles || data?.roles?.length === 0) {
            this.onLoginError({response})
            return
        }
        setToStorage("id_token", data?.id);
        setToStorage("user_id", data?.user?.id);
        setToStorage("user_data", JSON.stringify(data?.user));
        setToStorage("team_id", data?.team.id);
        setToStorage('team_name', data?.team?.name)
        if(response?.botId){
            setToStorage("bot_id", response.botId);
        }
        this.setState({ 
            spinnerStatus:false,
            userDef: {
                userName: '',
                password: '',
                MFACode: ''
            } 
        })
        this.props.updateUserData(data);
        if(!this.props.reloginState && !localStorage.getItem('bot_id')) {
            localStorage.removeItem('bot_id');
            // history.push('/');
            history.push('/bot-list');
        } else {
            let currentBotID = localStorage.getItem('bot_id');
            if(currentBotID && currentBotID !== 'undefined' && currentBotID !== 'null'){
                history.push(`/${currentBotID}/chatbot`);
            } else{
                this.props.blockUiFun(true);
                this.props.getBotListData(() => {
                }, () => {
                    this.props.blockUiFun(false);
                });
                this.props.getGenericData(this.props.currentLanguage, (res) => {
                    localStorage.setItem('bot_id', currentBotID);
                    this.props.getBotInfo(currentBotID);
                    this.props.getSelectedBotData(currentBotID, () => {
                        setTimeout(() => {this.props.blockUiFun(false);}, 3000)                 
                    }, () => {
                        this.props.blockUiFun(false);
                    });
                    history.push('' + window.location.pathname);
                });
            }
        }
    }

    onLoginError = (error) => {
        let err = error?.response
        this.handleFlashMessage(err?.data?.error?.message, "error");
        if (err?.data?.message === 'login failed') {
            this.handleFlashMessage("Invalid Credential", "error");
        } else if (err?.data?.roles && err?.data?.roles.length === 0) {
            this.handleFlashMessage("Cannot login as all user roles are revoked", "error");
        } else {
            this.handleFlashMessage(err?.data?.msg || err?.data?.message, "error");
        }
    }

    onreLoginSuccess = (response) => {
        console.log("relogin...");
        this.onLoginSuccess(response)
    }

    onReLoginExit = () => {
        // sessionStorage.removeItem("pwd_reset")
        // this.redirectTo('/', 'exit')
        // this?.props?.resetAgentsList(); // changing to initial state in store for agentList
    }

    render() {
        const { renderState,reloginstart,headerTitleData} = this.state;
        const { reloginState} = this.props;
        let emailProps = {}
        if (reloginState) {
            emailProps = {
                email: localStorage.getItem('user_data') ? JSON.parse(localStorage.getItem('user_data')).email : null
            }
        }
        return (
            <div className = 'bot-forge-body-wrapper login' style={{backgroundColor: '#f4f7fc'}}>
                <LoginV4
                    {...this.props}
                    logoImgSrc={BotForgeIcon}
                    environmentTag={process.env.CURRENT_ENV}
                    header={"Customize your chatbot user interface to speak your brand language"}
                    subHeader="Add custom elements to your bot interface and gamify UI elements to humanize your chatbot."
                    API_ENDPOINT={ "/api/v1/"}
                    flow={"login"}
                    subflow={""}
                    onLoginError={this.onLoginError}
                    onLoginSuccess={this.onLoginSuccess}
                    onreLoginSuccess={this.onreLoginSuccess}
                    onreLoginExit={this.onReLoginExit}
                    relogin={this.props.reloginState && !this.state.reloginstart }
                    ROUTES={{
                      SIGN_IN: "/signin",
                    }}
                    history={history}
                    ebPlatform="botforge" 
                    containerStyle={{height:"100vh"}}
                    microsoftLogin={rlibfn.envCheckSSO("microsoft", process.env?.REACT_APP_SSO_LOGIN)}
                    googleLogin={rlibfn.envCheckSSO("google", process.env?.REACT_APP_SSO_LOGIN)}
                    oktaLogin={rlibfn.envCheckSSO("okta", process.env?.REACT_APP_SSO_LOGIN)}
                    cancelReLoginBtn={this.props.reloginState && !this.state.reloginstart }
                    ENCRYPT_KEY={process.env.REACT_APP_ENCRYPT_KEY}
                    {...emailProps}
                    teamId={localStorage.getItem('team_id') || null}
                />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        currentLanguage: state.UiReducer && state.UiReducer.currentLanguage ? state.UiReducer.currentLanguage : 'en'
    };
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators({
    getMultifactorStatus,
    loginUser,
    updateUserData,
    getBotListData,
    doMultiFactorSetup,
    getSelectedBotData,
    getGenericData,
    blockUiFun,
    getBotInfo
  }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(Login);
